export const pastTensed = (present: string) =>
    present.endsWith('e') ? present + 'd' : present + 'ed'

export const capitalize = (text: string) =>
    text.substring(0, 1).toUpperCase() + text.substring(1, text.length)
